import { ID } from '@datorama/akita';
import { Instrument } from '@iv/model/instrument';
import {
  IChartFilter,
  IChartSeriesSettings,
  ISelectedFilters
} from '../../interfaces';

export interface IChartSeries<T = Instrument> {
  id: ID;
  stock: T;
  selectedFilters: ISelectedFilters;
  settings: IChartSeriesSettings;
  type: SeriesType;
  filters?:IChartFilter[]
}

export type SeriesType = SeriesTypeEnum.MAIN | SeriesTypeEnum.COMPARE;

export type SeriesUpdateOptionsType = LocalID | LocalStock | LocalFilters | LocalSettings | LocalSeriesType | IChartSeries;

interface LocalID {
  id: ID;
}

interface LocalStock {
  stock: Instrument;
}

interface LocalFilters {
  selectedFilters: ISelectedFilters;
}

interface LocalSettings {
  settings: IChartSeriesSettings;
}

interface LocalSeriesType {
  type: SeriesType;
}

export enum SeriesTypeEnum {
  MAIN = 'main',
  COMPARE = 'compare'
}
